import { useCallback } from 'react';

import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetBetLimits = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IGetBetLimitsResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IGetBetLimitsResponseData>({
            ID: 35634,
            responses: [35635, 35636],
            description: 'Get Player Bet Limits',
            errorLevel: 1
        });

        return data;
    }, [
        send
    ]);
};
